import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'

import Lock from 'Images/password_lock.svg'
import { Box, Icon, Heading, Image } from '@redriverpress/system'

import InputPassword from 'Common/components/forms/InputPassword'

import Loc from '../common/components/Loc'
import { Field } from '../common/utils/FormUtilComponents'
import {
  useStudentOnboardingContext,
  setPassword,
} from '../context/onboardingStudentContext'
import { STD_ONBOARDING_PATH } from '../common/constants'
import BottomNav from '../common/components/BottomNav'

export default function CreatePassword() {
  const history = useHistory()
  const [{ locale }, dispatch] = useStudentOnboardingContext()

  const schema = Yup.object().shape({
    password: Yup.string()
      .required('Password is required')
      .min(8, 'Minimum 8 characters'),
  })

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      minHeight='90vh'
    >
      <Formik
        initialValues={{ password: '' }}
        initialErrors={{ password: '' }}
        validationSchema={schema}
        validateOnBlur
        validateOnChange
        style={{ display: 'flex', flex: '1' }}
      >
        {formik => {
          const { errors, touched, values, isValid } = formik

          const isFieldValid = field =>
            touched[field] && !!values[field] && !errors[field]

          const getFieldBorderColor = field => {
            if (!touched[field]) return null
            if (errors[field]) return 'red700'
            return null
          }

          const getFieldRightIcon = field => {
            if (!touched[field]) return null

            if (isFieldValid(field))
              return (
                <Icon icon='check-circle' color='green700' weight='solid' />
              )

            return (
              <Icon icon='exclamation-circle' color='red700' weight='solid' />
            )
          }

          const handleSubmit = () => {
            dispatch(setPassword(values.password))
            history.push({ pathname: `${STD_ONBOARDING_PATH.signup}/summary` })
          }

          return (
            <Form
              autoComplete='off'
              style={{
                display: 'flex',
                flex: '1',
                flexDirection: 'column',
                width: '100%',
              }}
            >
              <Box
                display='flex'
                flexDirection='column'
                alignItems='center'
                ml={[null, null, '3rem', null]}
              >
                <Image
                  title='welcome'
                  alt='Welcome'
                  src={Lock}
                  height={['60px', null, null, '150px']}
                  mt={[3, null, 0]}
                  mb={[3, null, null, 2]}
                />
                <Heading fontSize={[3, null, 4, 5]} mb={3}>
                  Create a password
                </Heading>
                {!!locale && (
                  <Loc
                    fontSize={[1, null, 2]}
                    color='gray700'
                    fontWeight='600'
                    copy='Create a password'
                  />
                )}
                <Box
                  display='flex'
                  flexDirection='column'
                  alignItems='center'
                  mt={4}
                  width={[1, null, '80%', '50%']}
                >
                  <Box width={1} mb={3}>
                    {!!locale && (
                      <Loc
                        fontSize={0}
                        color='gray700'
                        fontWeight={['400', null, '600']}
                        copy='Password'
                      />
                    )}
                    <Field
                      // Since Field is a styled-component, we must use the forwardedAs prop (not as) to pass the InputPassword component
                      forwardedAs={InputPassword}
                      id='password'
                      name='password'
                      mb={0}
                      borderColor={getFieldBorderColor('password')}
                      iconRight={getFieldRightIcon('password')}
                      icon='key-skeleton'
                      placeholder='Password'
                    />
                  </Box>
                </Box>
              </Box>

              {/* Footer w/ nav */}
              <BottomNav
                prevLink={() =>
                  history.push({
                    pathname: `${STD_ONBOARDING_PATH.signup}/what-is-your-email`,
                  })
                }
                nextLink={handleSubmit}
                disabled={!isValid}
              />
            </Form>
          )
        }}
      </Formik>
    </Box>
  )
}
